import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { useTranslation } from "react-i18next";
import ColorProviderModal from "./colors/ColorProviderModal";

function ItemColors(props) {
  const { t } = useTranslation(["translation"]);
  const [selectedColor, setSelectedColor] = useState("#ffffff");
  const [selectedMode, setSelectedMode] = useState("Selected Item");
  const [showManufacturerModal, setShowManufacturerModal] = useState(false);

  // Handle manufacturer color selection
  const handleManufacturerColorSelect = (colorData) => {
    const colorValue = colorData.rgb || colorData.hex;
    setSelectedColor(colorValue);
    const activeMode = selectedMode;

    let itemType = "";
    if (selectedMode === "All Windows") itemType = "window";
    if (selectedMode === "All Doors") itemType = "doors";

    if (activeMode === "Selected Item") {
      props.updateColor?.(colorValue);
      props.handleColor?.({ hex: colorValue });
    } else if (itemType && props.applyColorToSpecificItems) {
      props.applyColorToSpecificItems(itemType, colorValue);

      // Reset bulk mode to default after applying to avoid accidental repeated mass updates.
      setSelectedMode("Selected Item");
    }
  };

  return (
    <div className="d-inline dropup">
      {/* Color Bucket Button - Opens Manufacturer Color Modal Directly */}
      <button
        className="btn mt-1 btn-block pb-0 m-0 btn-primary btn-sm"
        onClick={() => setShowManufacturerModal(true)}
      >
        <img 
          src="/icons/colorBucketButton.png" 
          height="41px"
          alt="Color"
        />
      </button>

      {/* Manufacturer Color Provider Modal with Mode Selector */}
      <ColorProviderModal
        show={showManufacturerModal}
        onHide={() => setShowManufacturerModal(false)}
        onColorSelect={handleManufacturerColorSelect}
        onUseAsReferenceImage={props.onUseColorSwatchAsReferenceImage}
        currentColor={selectedColor}
        title={t("colorProvider.title", "Select Manufacturer Color")}
        selectedMode={selectedMode}
        setSelectedMode={setSelectedMode}
      />
    </div>
  );
}

export default ItemColors;
